import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { addFormData, fetchAllDashboardDataAPI } from '../../utils/api';

const TopAgentProduct = () => {
    const centerid = localStorage.getItem('centerdata');
    const [topagent, setTopAgent] = useState([])

    useEffect(() => {
        getTopAgent(centerid)
    }, [centerid])

    const getTopAgent = (centerid) => {
        fetchAllDashboardDataAPI('center-get-top-agent-for-dashboard-data', centerid).then((resp) => {
            if (resp.data.status === 1) {
                setTopAgent(...[resp.data.topagent])
            }
        })
    }
    const handleInputs = e => {
        const data = {valuetype:e.target.value, centerid:centerid}
        addFormData('center-get-top-type-agent-for-dashboard-data',data).then((resp)=>{
            if (resp.data.status === 1) {
                setTopAgent(...[resp.data.topagent])
            }
        })
    };
    return (
        <div className="topagentproduct card radius-10 overflow-hidden w-100">
            <div className="card-header border-bottom bg-transparent">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="headingtitle">
                        <h6>Top Agents</h6>
                    </div>
                    <div className="select">
                        <Form.Select
                            placeholder="Member Type"
                            name="agent_wise"
                            className="topagentselect"
                            onChange={handleInputs}
                        >
                            <option value="Today">Today</option>
                            <option value="Yesterday">Yesterday</option>
                            <option value="Week">Week</option>
                            <option value="Month">Month</option>
                        </Form.Select>
                    </div>
                </div>
            </div>
            <div className="topagentproductsection">
                {topagent?.map((topagent, index) => (
                    <div className="agentbody" key={index}>
                        <span className="name">{topagent?.agent_name}</span>
                        <span className="name">{topagent?.total_count}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TopAgentProduct